import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';
import money from 'alpinejs-money';
import persist from '@alpinejs/persist';

import Cart from './cart';
import Dropdown from './dropdown';
import MegaMenu from './mega-menu';
import ProductPagination from './product-pagination';
import QuickCart from './quick-cart';
import Slider from './slider';

document.addEventListener('alpine:init', () => {
  Alpine.store('Cart', Cart());

  Alpine.data('Dropdown', Dropdown);
  Alpine.data('MegaMenu', MegaMenu);
  Alpine.data('ProductPagination', ProductPagination);
  Alpine.data('QuickCart', QuickCart);
  Alpine.data('Slider', Slider);
});

window.Alpine = Alpine;

Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.plugin(money);
Alpine.plugin(persist);

Alpine.start();
